import React, {useEffect} from "react";
import './AnalizaMain.css'
import * as BiIcons from "react-icons/bi";
import {useHistory} from "react-router-dom";
import MathJax from 'react-mathjax-preview';
import TeX from "@matejmazur/react-katex";

export default function Kwantyfikatory(){

    useEffect(()=>{
        document.title="Kwantyfikatory";
    },[])

    const { push } = useHistory();

    const comeBackFunc=()=>{
        push('/analiza/pojecia-wstepne');
    }

    return(
        <div className='conceptsContainer'>

            <div className='comeBackDiv' onClick={comeBackFunc}>
                <BiIcons.BiArrowBack/>
                <div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
            </div>

            <h3>Symbole:</h3>
            <p>&#8896;(&#8704;, &#8719;) - nazywany jest kwantyfikatorem dużym lub kwantyfikatorem ogólnym</p>
            <p>&#8897;(&#8707;, &#8721;)  - nazywany jest kwantyfikatorem małym lub kwantyfikatorem szczegółowym.</p>

            <br/><br/>
            <h3>Kwantyfikatory stosujemy głównie do zapisu funkcji zdaniowych.</h3>
            <p>Jeśli S(x) oraz P(x) oznaczają odpowiednio dwie funkcje zdaniowe to zapis:</p>
            <p><MathJax math={'`bigwedge_x S(x)`'}/></p>
            <p>oznacza, że dla każdego <TeX math={'x'}/> jest S(<TeX math={'x'}/>),</p><br/>
            <p><MathJax math={'`bigvee_x S(x)`'}/></p>
            {/*<p className='oneLine'><div className='column'>&#8897;<sub>x</sub></div>&nbsp; S(x)</p>*/}
            <p>oznacza, że istnieje takie <TeX math={'x'}/>, że S(<TeX math={'x'}/>),</p><br/>
            {/*<p className='oneLine'><div className='column'>&#8896;<sub>P(x)</sub></div>&nbsp; S(x)</p>*/}
            <p><MathJax math={'`bigwedge_(P(x)) S(x)`'}/></p>
            <p>oznacza, że dla każdego <TeX math={'x'}/> spęłniającego warunek P(<TeX math={'x'}/>) zachodzi S(<TeX math={'x'}/>),</p><br/>
            {/*<p className='oneLine'><div className='column'>&#8897;<sub>P(x)</sub></div>&nbsp; S(x)</p>*/}
            <p><MathJax math={'`bigvee_(P(x)) S(x)`'}/></p>
            <p>oznacza, że istnieje takie <TeX math={'x'}/> spęłniające P(<TeX math={'x'}/>), dla którego zachodzi S(<TeX math={'x'}/>).</p>
            <br/><br/><br/>
            <p>Przykłady:</p>
            {/*<p className='oneLine'><div className='column'>&#8896;<sup>x&#62;3</sup></div>x<sup>2</sup>&#62;9</p>*/}
            <p><MathJax math={'`bigwedge_(x&#62;3) x^2&#62;9`'}/></p>
            <p>powyższe zdanie jest prawdziwe, ponieważ dla każdej liczby większej od 3, jej kwadrat będzie większy od 9.</p>
            <p>Natomiast jeśli zamienimy dane i zapiszemy zdanie:
                {/*<div className='column'>&#8896;<sub>x<sup>2</sup>&#62;9</sub></div>x&#62;3*/}
            </p>
            <p><MathJax math={'`bigwedge_(x^2&#62;9) x&#62;3`'}/></p>
            <p>będzie nieprawdziwe, ponieważ np. liczba x=-5 nie spełnia powyższego zdania.</p>

            <br/><br/>

            <p>Zaprzeczanie zdań z kwantyfikatorami:</p>

            <p><MathJax math={'`&#8764; bigwedge_(x&#8712;X) S(x)&#8660;bigvee_(x&#8712;X) (&#8764;S(x))`'}/></p>
            <p><MathJax math={'`&#8764; bigvee_(x&#8712;X) S(x)&#8660;bigwedge_(x&#8712;X) (&#8764;S(x))`'}/></p>
            <p><MathJax math={'`&#8764; bigwedge_(x&#8712;X)bigvee_(y&#8712;Y) S(x,y)&#8660;bigvee_(x&#8712;X)bigwedge_(y&#8712;Y) (&#8764;S(x,y))`'}/></p>
            {/*<p className='oneLine'><div className='column'>&#8764; &#8896;<sub><small>&nbsp;&nbsp;&nbsp;&nbsp;x&#8712;X
                </small></sub></div>&nbsp;S(x) &#8660; <div className='column'>&#8897;
                        <sub><small>x&#8712;X</small></sub></div> &nbsp;(&#8764;S(x))</p>*/}

            {/*<p className='oneLine'><div className='column'>&#8764; &#8897;<sub><small>&nbsp;&nbsp;&nbsp;&nbsp;x&#8712;X</small>
                </sub></div> &nbsp;S(x) &#8660; <div className='column'> &#8896;<sub><small>x&#8712;X</small></sub></div>
                        &nbsp;(&#8764;S(x))</p>*/}

            {/*<p className='oneLine'><div className='column'><div>&#8764; &#8896;</div><sub><small>&nbsp;&nbsp;&nbsp;&nbsp;
                        x&#8712;X</small></sub></div>
                    &nbsp;<div className='column'>&#8897;<sub><small>y&#8712;Y</small></sub></div> S(x,y) &#8660;
                    &nbsp;<div className='column'>&#8897;<sub><small>x&#8712;X</small></sub></div>
                    &nbsp;<div className='column'>&#8896;<sub><small>y&#8712;Y</small></sub></div> (&#8764;S(x,y))</p>*/}

            <p>Przy zaprzeczaniu duży kwantyfikator przechodzi w mały, mały przechodzi w duży, oraz zdanie <TeX math={'S(x,y)'}/> przechodzi
            w zdanie &#8764;<TeX math={'S(x,y)'}/>.</p>

            <br/><br/>


        </div>
    );
}